import { createSlice } from '@reduxjs/toolkit'
import { sortByProp } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { convertDataCreditChartRiskScore } from '../../../../../helpers/score'
import { PERIOD_TYPE, SCORE_TABS } from '../constant'
import { getCreditRiskScore, getPerformanceScore } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryAnalysis/score',
  initialState: {
    isLoading: true,
    typeOrder: [],
    tab: SCORE_TABS.performance.key,
    period: PERIOD_TYPE.yearly.value,
    isShowRange: true,
    lastYear: undefined,
    creditRiskScore: [],
    performanceScore: [],
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading = true
      state.creditRiskScore = []
      state.performanceScore = []
      state.typeOrder = []
      state.tab = SCORE_TABS.performance.key
    },
    changeTab: (state, action) => {
      state.tab = action.payload
    },
    changePeriod: (state, action) => {
      state.period = action.payload
    },
    changeIsShowRange: (state, action) => {
      state.isShowRange = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCreditRiskScore.pending, (state) => {
      state.isLoading = true
      state.creditRiskScore = []
      state.typeOrder = []
    })
    builder.addCase(
      getCreditRiskScore.fulfilled,
      (state, { payload = [], meta }) => {
        state.isLoading = false

        state.typeOrder = [...new Set(payload.map((item) => item.typeOrder))]
        state.creditRiskScore = convertDataCreditChartRiskScore(
          payload,
          meta.arg['Period'],
        )
        const sortByPublicDateId = sortByProp(payload, 'publicDateId', true)
        state.lastYear = sortByPublicDateId.length
          ? sortByPublicDateId[0].publicDateId
          : undefined
      },
    )
    builder.addCase(getCreditRiskScore.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })

    builder.addCase(getPerformanceScore.pending, (state) => {
      state.isLoading = true
      state.performanceScore = []
      state.typeOrder = []
    })
    builder.addCase(
      getPerformanceScore.fulfilled,
      (state, { payload = [], meta }) => {
        state.isLoading = false

        state.typeOrder = [...new Set(payload.map((item) => item.typeOrder))]
        state.performanceScore = convertDataCreditChartRiskScore(
          payload,
          meta.arg['Period'],
        )
        const sortByPublicDateId = sortByProp(payload, 'publicDateId', true)
        state.lastYear = sortByPublicDateId.length
          ? sortByPublicDateId[0].publicDateId
          : undefined
      },
    )
    builder.addCase(getPerformanceScore.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
  },
})

register(slice.name, slice.reducer)

export const selectScoreIndustryAnalysis = (state) => state[slice.name]
export const selectLoadingScore = (state) => state[slice.name].isLoading
export const selectCreditRiskScore = (state) =>
  state[slice.name].creditRiskScore
export const selectPerformanceScore = (state) =>
  state[slice.name].performanceScore
export const selectTypeOrder = (state) => state[slice.name].typeOrder
export const selectTab = (state) => state[slice.name].tab
export const selectPeriod = (state) => state[slice.name].period
export const selectIsShowRange = (state) => state[slice.name].isShowRange
export const selectLastYear = (state) => state[slice.name].lastYear

export const { changeTab, changePeriod, changeIsShowRange } = slice.actions
